import React from "react";
import {
  Text,
  Heading,
  Wrapper,
  ClockIcon,
  Container,
  CTAButton,
  ContentBox,
  CheckmarkIcon,
  ClipboardIcon,
  Image,
} from "./OrderComplete.styles";

const OrderComplele = () => {
  return (
    <Wrapper>
      <Container>
        <ClockIcon src="/svgs/clock.svg" width={65} height={65} alt="clock" />
        <CheckmarkIcon src="/svgs/checkmark.svg" width={65} height={65} alt="checkmark" />
        <ContentBox>
          <Heading>Your Order is Complete</Heading>
          <Text>
            Thank you for your order! Your order is being processed and will be completed within 3-6
            hours. You will receive an email confirmation when your order is completed.
          </Text>
          <CTAButton to="/">Continue Shopping</CTAButton>
        </ContentBox>
        <ClipboardIcon src="/svgs/clipboard.svg" width={65} height={65} alt="clipboard" />
      </Container>
      <Image src={"/images/bottom_image.jpeg"} />
    </Wrapper>
  );
};

export default OrderComplele;
